module.exports = __webpack_public_path__ + "img/crts_card_image.9f223c04.jpg";